var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6983 24.2446L20.8325 19.3787C22.3465 17.5424 23.2571 15.1904 23.2571 12.6286C23.2571 6.76846 18.4887 2 12.6286 2C6.76846 2 2 6.76846 2 12.6286C2 18.4887 6.76846 23.2571 12.6286 23.2571C15.189 23.2571 17.541 22.3465 19.3787 20.8325L24.2446 25.6983C24.4448 25.8985 24.7081 26 24.9714 26C25.2347 26 25.4981 25.8999 25.6983 25.6983C26.1001 25.2965 26.1001 24.6464 25.6983 24.2446ZM4.05714 12.6286C4.05714 7.90263 7.90263 4.05714 12.6286 4.05714C17.3545 4.05714 21.2 7.90263 21.2 12.6286C21.2 17.3545 17.3545 21.2 12.6286 21.2C7.90263 21.2 4.05714 17.3545 4.05714 12.6286Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.556ef1fb8aa6dd01f641b90c7ab2ba9b.svg";
export { ForwardRef as ReactComponent };